<template>
  <Resizer :id="rptElementId" :style="elementCss" :index="index" :elmData="elmData" :maxPos="maxPos">
    <ReportMenu slot="menu" :elmData="elmData" :index="index" @removeClicked="$emit('removeClicked', index)"></ReportMenu>
    <span slot="elmDText" class="noselect" style="padding-right: 10px;">{{elmData.text}}</span>
  </Resizer>
</template>
<script>
  import ReportMenu from './ReportMenu'
  import Resizer from './Resizer'
  export default {
    name: 'ReportElement',
    props: ['index', 'elmData', 'maxPos'],
    components: { ReportMenu, Resizer },
    data () {
      return {
        isActive: false,
        isOpen: false,
        isEditText: false,
        fontSizePx: '14px'
      }
    },
    mounted () {
      this.$bus.$on('activeElement', (args) => {
        this.isActive = (this.rptElementId === args.rptElementId)
      })
    },
    ready: function () {
    },
    beforeDestroy: function () {
    },
    computed: {
      rptElementId () {
        return this.$root.getGUID()
      },
      resizerId () {
        return this.$root.getGUID()
      },
      elementCss () {
        return {
          position: 'absolute',
          top: this.elmData.top + 'in',
          left: this.elmData.left + 'in',
          width: this.elmData.width + 'in',
          height: this.elmData.height + 'in',
          fontWeight: this.elmData.bold ? 'bold' : '',
          backgroundColor: this.elmData.background_color,
          textAlign: this.elmData.align ? this.elmData.align : 'left', // 'left' , 'center' , 'right'
          border: '1px dotted rgba(0,0,0,0.5)',
          zIndex: 0,
          fontSize: this.elmData.fontsize ? this.elmData.fontsize + 'px' : '14px'
        }
      }
    },
    methods: {
      onResize: function (x, y, w, h) {
        console.log('left = ' + this.elmData.left)
        console.log('x = ' + x)
        // console.log('y = ' + y)
        // console.log('w = ' + w)
        // console.log('h = ' + h)
        this.elmData.width = w / 96
        this.elmData.height = h / 96
        this.elmData.left = x / 96
        this.elmData.top = y / 96
        console.log('left = ' + this.elmData.left)
        this.activateElement()
      },
      onDrag: function (x, y) {
        this.elmData.left = x / 96
        this.elmData.top = y / 96
        this.activateElement()
      }
    }
  }
</script>
<style>
  .txtClear {
    background-color: transparent;
    border: none;
    width: 100%;
  }
  .elementResize {
    position: absolute;
    cursor: pointer;
    bottom: 0px;
    right: 0;
    width: 10px;
    height: 10px;
    cursor: nwse-resize;
  }

  div.rptElement > div.resizer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    resize: both;
    overflow: hidden;
    cursor: move;
    background-color: rgba(0,0,0,0.1);
    border: 1px dotted rgba(255,255,0,0.5);
    resize: both;
    cursor: move;
  }
  div.rptElement:hover > div.resizer {
    display: block;
    border: 1px dotted rgba(255,255,0,0.5);
  }
</style>



// WEBPACK FOOTER //
// ReportElement.vue?27d377c3